import { CategoryFull, CategoryVariant } from 'modules/shared/modules/categories-shared/interfaces/category-full.interface';
import BreadcrumbsInterface from 'interfaces/breadcrumbs.interface';
import PhotosInterface from 'interfaces/photo.interface';
import OfferInterface from 'interfaces/offer.interface';
import DealerInterface from 'interfaces/dealer.interface';
import OpinionsInterface from 'interfaces/opinions.interface';
import AttributesInterface from 'interfaces/attributes.interface';
import ProducerInterface from 'interfaces/producer.interface';
import CategoryInterface from 'interfaces/category.interface';
import ProductDescriptionInterface from 'modules/product/interfaces/product-description.interface';
import { ABTestsInterface } from 'modules/ab-test/ab-test.interface';

export enum RankingSeoRobots {
    INDEX_FOLLOW = 'index, follow',
}

export interface CategoryRankingPage {
    category: CategoryFull;
    products: {
        count: number;
        items: {
            id: number;
            name: string;
            categoryId: number;
            rank: number;
            url: string;
            partNo: string;
            isbn: number[];
            ean: string[];
            photos: {
                main: PhotosInterface | null;
            };
            description: {
                text: ProductDescriptionInterface['text'];
                content: ProductDescriptionInterface['content'];
            };
            offers: {
                count: number;
                items: {
                    url: OfferInterface['url'];
                    price: OfferInterface['price'];
                    dealer: {
                        name: DealerInterface['name'];
                    };
                }[];
            };
            opinions: OpinionsInterface;
            attributes: AttributesInterface[];
            producer: ProducerInterface;
            minPrice: number;
            maxPrice: number;
            prevPrice: number;
            discount: number;
            category: Pick<CategoryInterface, 'name'>;
        }[];
    };
    breadcrumbs: BreadcrumbsInterface[];
    isAdultAccepted: boolean;
    variant: CategoryVariant;
    lead: string | null;
    abTestRankingReadMore: Pick<ABTestsInterface, 'rankingReadMore'>;
}
